var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransactionBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5597 11.2132L11.2913 10.0259L12.6117 9.57563L12.758 8.18884L13.7514 7.21088L13.2791 5.89819L13.7514 4.58547L12.758 3.6075L12.6117 2.22075L11.2914 1.77044L10.5597 0.583156L9.1758 0.75025L8.00021 0L6.82462 0.750313L5.44074 0.583219L4.70909 1.77047L3.38871 2.22078L3.24243 3.60753L2.24902 4.5855L2.72134 5.89822L2.24902 7.21094L3.2424 8.18888L3.38868 9.57566L4.70905 10.026L5.44071 11.2132L6.82462 11.0462L8.00021 11.7964L9.1758 11.0462L10.5597 11.2132ZM3.95555 5.89822C3.95555 3.668 5.76999 1.85356 8.00021 1.85356C10.2304 1.85356 12.0449 3.668 12.0449 5.89822C12.0449 8.12844 10.2304 9.94287 8.00021 9.94287C5.76999 9.94287 3.95555 8.12844 3.95555 5.89822Z",
    fill: "#DB7802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 2.79163C6.28715 2.79163 4.89355 4.18522 4.89355 5.89819C4.89355 7.61116 6.28715 9.00475 8.00012 9.00475C9.71309 9.00475 11.1067 7.61116 11.1067 5.89819C11.1067 4.18522 9.71309 2.79163 8.00012 2.79163Z",
    fill: "#DB7802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60324 12.0178L4.95699 12.2165L4.08721 10.805L3.79152 10.7042L2.51611 14.6907L4.81221 14.5644L6.60861 16L7.66574 12.6959L6.60324 12.0178Z",
    fill: "#DB7802"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.913 10.8051L11.0432 12.2165L9.39697 12.0178L8.33447 12.6959L9.3916 16L11.188 14.5644L13.4841 14.6907L12.2087 10.7042L11.913 10.8051Z",
    fill: "#DB7802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionBonus);
export default __webpack_public_path__ + "static/media/icon_transaction_bonus.24fb58010f12f881f8804a4c7bb7736b.svg";
export { ForwardRef as ReactComponent };